/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */
import { addLocaleData } from "react-intl";
import enLocaleData from "react-intl/locale-data/en";
import esLocaleData from "react-intl/locale-data/es";
import ptLocaleData from "react-intl/locale-data/pt";
import zhLocaleData from "react-intl/locale-data/zh";

import enTranslationMessages from "./translations/en.json";
import esTranslationMessages from "./translations/es.json";
import ptTranslationMessages from "./translations/pt.json";
import zhTranslationMessages from "./translations/zh.json";

import { getLang } from "./utils/url_parser";

addLocaleData(enLocaleData);
addLocaleData(esLocaleData);
addLocaleData(ptLocaleData);
addLocaleData(zhLocaleData);

export const DEFAULT_LOCALE = getLang();

// prettier-ignore
export const appLocales = [
  "en",
  "es",
  "pt",
  "zh"
];

export const formatTranslationMessages = (locale, messages) => {
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

export const translationMessages = {
  en: formatTranslationMessages("en", enTranslationMessages),
  es: formatTranslationMessages("es", esTranslationMessages),
  pt: formatTranslationMessages("pt", ptTranslationMessages),
  zh: formatTranslationMessages("zh", zhTranslationMessages)
};
